import {
  ExamTimeOfDay,
  TestCentreOverviewAvailableDistrictDto,
  TestCentreOverviewDateDto,
  TestCentreOverviewDistrictDto,
  TestCentreOverviewSessionDto,
  TestCentreOverviewSummaryDto,
  TestCentreOverviewVenueDto,
  testCentreOverviewClient,
} from 'api/planning';
import { api } from '../api';
import { TEST_CENTRE_OVERVIEW_QUERY_TAG } from '../query-tags';

export type TestCentreOverviewQueryFilters = {
  fromDate?: string;
  toDate?: string;
  districtIds?: number[];
  venueIds?: number[];
  sessionTimes?: ExamTimeOfDay[];
};

export const testCentreOverviewApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTestCentreOverviewDistricts: builder.query<TestCentreOverviewAvailableDistrictDto[], void>({
      query: () => testCentreOverviewClient.getDistricts(),
    }),
    getTestCentreOverviewVenues: builder.query<
      TestCentreOverviewVenueDto[],
      { districtIds: number[] }
    >({
      query: ({ districtIds }) => testCentreOverviewClient.getVenues(districtIds),
    }),
    getTestCentreOverviewDates: builder.query<
      TestCentreOverviewDateDto[],
      { centreId: number | undefined; filters: TestCentreOverviewQueryFilters }
    >({
      query: ({ filters }) => testCentreOverviewClient.getDates(filters),
    }),
    getTestCentreOverviewSummary: builder.query<
      TestCentreOverviewSummaryDto,
      { filters: TestCentreOverviewQueryFilters }
    >({
      query: ({ filters }) => testCentreOverviewClient.getSummary(filters),
      providesTags: [TEST_CENTRE_OVERVIEW_QUERY_TAG],
    }),
    getTestCentreOverviewDistrictsForDate: builder.query<
      TestCentreOverviewDistrictDto[],
      { centreId: number | undefined; date: string; filters: TestCentreOverviewQueryFilters }
    >({
      query: ({ date, filters }) => testCentreOverviewClient.getDistrictsForDate(date, filters),
      keepUnusedDataFor: 300,
      providesTags: [TEST_CENTRE_OVERVIEW_QUERY_TAG],
    }),
    getTestCentreOverviewSessionsForDistrict: builder.query<
      TestCentreOverviewSessionDto[],
      {
        centreId: number | undefined;
        date: string;
        districtId: number;
        filters: TestCentreOverviewQueryFilters;
      }
    >({
      query: ({ date, districtId, filters }) =>
        testCentreOverviewClient.getSessionsForDistrict(date, districtId, filters),
      keepUnusedDataFor: 300,
      providesTags: [TEST_CENTRE_OVERVIEW_QUERY_TAG],
    }),
  }),
});

export const {
  useGetTestCentreOverviewDistrictsQuery,
  useGetTestCentreOverviewVenuesQuery,
  useGetTestCentreOverviewDatesQuery,
  useGetTestCentreOverviewSummaryQuery,
  useGetTestCentreOverviewDistrictsForDateQuery,
  useGetTestCentreOverviewSessionsForDistrictQuery,
} = testCentreOverviewApi;
